import type { Country } from "@/Common/Models/Domain/Country";
import type { TherapistAction } from "@/Modules/Therapist/Models/Ui/Therapist";
import type { Gender } from "@/Common/Models/Domain/Gender";

export interface TherapistApi {
  uuid: string;
  nif: string;
  ccc: string;
  address: string;
  therapist_license_number: string;
  level: number;
  gender: Gender;
  fast_assignment: false;
  areas: TherapistAreaApi[];
  availability: TherapistAvailabilityApi;
  capacity: number;
  capacity_afternoon: number;
  capacity_morning: number;
  capacity_updated: number;
  stripe_account_id: string;
  stripe_account_status: string; // is this an enum?
  is_stripe_connect_available: boolean;
  is_trp_enabled: boolean;
  currents: TherapistCurrentApi[];
  educations: TherapistEducationApi[];
  is_edit_profile_popup: boolean;
  additional_languages: AdditionalLanguagesApi[];
  trp_level_changed: boolean;
  prev_trp_level: number;
  is_transcription_available: boolean;
  min_price_per_session?: number | null;
}

export interface TherapistAreaApi {
  area_i18n: string;
  area_id: string;
  area: string; // is this an Enum?
  country: Country;
  is_active: boolean;
  sub_area_i18n: string;
  sub_area_id: number;
  sub_area: string;
}

export interface TherapistCurrentApi {
  i18n: string;
  text: string;
  uuid: string;
  is_active: boolean;
}

export interface TherapistUpdateCurrentApiQuery {
  uuid: string;
  is_active: boolean;
}
export interface TherapistCreateEducationApiQuery {
  title: string;
  institution: string;
}

export interface TherapistUpdateEducationApiQuery {
  uuid: string;
  title: string;
  institution: string;
}

export interface TherapistActionApiQuery {
  action_key: TherapistAction;
}

export interface TherapistDeleteEducationApiQuery {
  uuid: string;
}

export interface TherapistEducationApi {
  uuid: string;
  title: string;
  institution: string;
}

export interface TherapistUpdateApiQuery {
  ccc?: string;
  availability_id?: number;
  areas?: TherapistAreaApi[];
  capacity_morning?: number;
  capacity_afternoon?: number;
  fast_assignment?: boolean;
  min_price_per_session?: number;
}

export interface TherapistAvailabilityApi {
  i18n: string;
  id: number;
  text: string;
  uuid: string;
}

export enum TherapistLevelGoalIdentifierApi {
  DAYS_IN_LEVEL = "days_in_level",
  ACTIVE_PATIENTS = "active_patients",
  SQQ1_SCORE = "sqq1_score",
  SQQ2_SCORE = "sqq2_score",
  TRIAL_TO_SUBSCRIPTION_RATE = "trial_to_subscription_rate",
}

export interface TherapistLevelGoalApi {
  current_value: string;
  identifier: TherapistLevelGoalIdentifierApi;
  max_value: string;
  min_value: string;
  percentage: number;
  status: string; // maybe enum?
}

export interface TherapistLevelApi {
  goals: TherapistLevelGoalApi[];
  level: number;
  max_level: number;
  progress: string; // maybe enum??
}

export interface TherapistStripeAccountApi {
  account_link: string;
}

export interface AdditionalLanguagesApi {
  i18n: string;
  text: string;
  uuid: string;
  is_active: boolean;
}

export interface TherapistUpdateAdditionalLanguagesApiQuery {
  uuid: string;
  is_active: boolean;
}
